import { render, staticRenderFns } from "./SOV.vue?vue&type=template&id=e3a7738c&scoped=true"
import script from "./SOV.vue?vue&type=script&lang=js"
export * from "./SOV.vue?vue&type=script&lang=js"
import style0 from "./SOV.vue?vue&type=style&index=0&id=e3a7738c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a7738c",
  null
  
)

export default component.exports